/* FIN custom sections — interactions and scroll motion.
   Loads GSAP + ScrollTrigger once, then wires up every [data-fin] element.
   Re-initialises when a section is added or edited in the theme editor. */
(function () {
  if (window.__finMotion) return;
  window.__finMotion = true;

  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gsapReady = null;

  function load(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function getGsap() {
    if (reduce) return Promise.resolve(null);
    if (window.gsap && window.ScrollTrigger) return Promise.resolve(window.gsap);
    if (!gsapReady) {
      gsapReady = (window.gsap ? Promise.resolve() : load(GSAP_SRC))
        .then(function () { return window.ScrollTrigger ? null : load(ST_SRC); })
        .then(function () { window.gsap.registerPlugin(window.ScrollTrigger); return window.gsap; })
        .catch(function () { return null; });
    }
    return gsapReady;
  }

  /* Each section keeps a list of cleanup functions so the theme editor can re-run it cleanly. */
  var cleanups = new WeakMap();
  function addCleanup(root, fn) { var a = cleanups.get(root) || []; a.push(fn); cleanups.set(root, a); }
  function teardown(root) { (cleanups.get(root) || []).forEach(function (fn) { try { fn(); } catch (e) {} }); cleanups.delete(root); }

  var init = {
    ticker: function (root) {
      var msgs = [].slice.call(root.querySelectorAll('.fin-ticker__msg'));
      if (msgs.length < 2) return;
      var i = 0, ms = (+root.dataset.interval || 4) * 1000;
      function show(d) {
        msgs[i].setAttribute('aria-hidden', 'true'); msgs[i].tabIndex = -1;
        i = (i + d + msgs.length) % msgs.length;
        msgs[i].setAttribute('aria-hidden', 'false'); msgs[i].removeAttribute('tabindex');
      }
      var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      var onP = function () { show(-1); }, onN = function () { show(1); };
      prev && prev.addEventListener('click', onP); next && next.addEventListener('click', onN);
      var t = reduce ? null : setInterval(function () { show(1); }, ms);
      addCleanup(root, function () { clearInterval(t); });
    },

    range: function (root) {
      var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
      function select(tab) {
        tabs.forEach(function (t) { var on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p) {
          var on = p.id === tab.getAttribute('aria-controls');
          p.hidden = !on;
          if (on && !reduce) { p.classList.remove('is-swap'); void p.offsetWidth; p.classList.add('is-swap'); }
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          n.focus(); select(n);
        });
      });
      root.__finSelect = select;
    },

    hotspots: function (root) {
      root.querySelectorAll('.fin-hs button').forEach(function (b) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') === 'true';
          root.querySelectorAll('.fin-hs button').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.hidden = true; });
          if (!open) { b.setAttribute('aria-expanded', 'true'); b.nextElementSibling.hidden = false; }
        });
      });
    },

    count: function (root) {
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; io.unobserve(e.target);
          var el = e.target, to = parseFloat(el.dataset.count); if (!to) return;
          var t0 = performance.now(), dur = 1200;
          (function step(t) {
            var p = Math.min(1, (t - t0) / dur);
            el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('[data-count]').forEach(function (el) { io.observe(el); });
      addCleanup(root, function () { io.disconnect(); });
    },

    buybar: function (root) {
      var bar = root.querySelector('.fin-buybar');
      var after = +root.dataset.after || 600;
      var foot = document.querySelector('footer, .footer, #shopify-section-footer, [id*="__footer"]');
      var atFoot = false;
      function upd() {
        var on = window.scrollY > after && !atFoot;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', !on);
        bar.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      }
      window.addEventListener('scroll', upd, { passive: true });
      var io = null;
      if (foot && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) { atFoot = es[0].isIntersecting; upd(); });
        io.observe(foot);
      }
      upd();
      addCleanup(root, function () { window.removeEventListener('scroll', upd); io && io.disconnect(); });
    }
  };

  /* Scroll motion — needs GSAP. Content is fully visible without it. */
  var motion = {
    hero: function (root, gsap) {
      var st = { trigger: root, start: 'top top', end: 'bottom top', scrub: true };
      var a = [
        gsap.to(root.querySelector('.fin-hero__media'), { yPercent: -12, scale: 1.06, ease: 'none', scrollTrigger: st }),
        gsap.to(root.querySelector('.fin-hero__copy'), { yPercent: -18, ease: 'none', scrollTrigger: Object.assign({}, st) }),
        gsap.to(root.querySelector('.fin-hero__halo'), { scale: 1.25, ease: 'none', scrollTrigger: Object.assign({}, st) })
      ];
      return a;
    },
    reveal: function (root, gsap) {
      return [].slice.call(root.querySelectorAll('[data-reveal]')).map(function (el) {
        return gsap.from(el, { y: 40, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
      });
    },
    hrun: function (root, gsap) {
      var track = root.querySelector('.fin-track');
      var mm = gsap.matchMedia();
      mm.add('(min-width: 900px)', function () {
        var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
        gsap.to(track, { x: function () { return -dist(); }, ease: 'none',
          scrollTrigger: { trigger: root, start: 'top top+=' + (+root.dataset.offset || 0), end: function () { return '+=' + dist(); }, pin: true, scrub: 0.8, invalidateOnRefresh: true, anticipatePin: 1 } });
      });
      return [mm];
    },
    stack: function (root, gsap) {
      var cards = [].slice.call(root.querySelectorAll('.fin-card'));
      var out = [];
      cards.forEach(function (c, i) {
        var next = cards[i + 1]; if (!next) return;
        var tl = gsap.timeline({ scrollTrigger: { trigger: next, start: 'top bottom', end: 'top 20%', scrub: true } });
        tl.to(c, { scale: 0.93, ease: 'none' }, 0).to(c.querySelector('.fin-card__shade'), { opacity: 0.28, ease: 'none' }, 0);
        out.push(tl);
      });
      return out;
    }
  };

  function setup(scope) {
    var roots = [].slice.call((scope || document).querySelectorAll('[data-fin]'));
    if (scope && scope.matches && scope.matches('[data-fin]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.__finDone) return; root.__finDone = true;
      var kinds = root.dataset.fin.split(/\s+/);
      kinds.forEach(function (k) { init[k] && init[k](root); });
      var wantsMotion = kinds.some(function (k) { return motion[k]; });
      if (!wantsMotion) return;
      getGsap().then(function (gsap) {
        if (!gsap || !root.isConnected) return;
        var made = [];
        kinds.forEach(function (k) { if (motion[k]) made = made.concat(motion[k](root, gsap)); });
        addCleanup(root, function () {
          made.forEach(function (m) { if (!m) return; if (m.revert) m.revert(); else if (m.kill) { m.scrollTrigger && m.scrollTrigger.kill(); m.kill(); } });
        });
        window.ScrollTrigger.refresh();
      });
    });
  }

  function onReady() {
    setup(document);
    window.addEventListener('load', function () { window.ScrollTrigger && window.ScrollTrigger.refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-fin]').forEach(function (r) { teardown(r); r.__finDone = false; });
    setTimeout(function () { window.ScrollTrigger && window.ScrollTrigger.refresh(); }, 50);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    var range = e.target.closest && e.target.closest('[data-fin~="range"]');
    if (tab && range && range.__finSelect) range.__finSelect(tab);
  });
})();
